export class TermsPageModel {
	Title: string;
	Context: string;
}
